import React from "react";
import { useMerchantTheme } from "@/hooks/useMerchantTheme";
import UserDataForm from "./UserDataForm";
import UserDataForm1xbet from "./UserDataForm1xbet";

function UserDataFormIndex(props) {
  const { is1xbet } = useMerchantTheme();
  return is1xbet ? (
    <UserDataForm1xbet {...props} />
  ) : (
    <UserDataForm {...props} />
  );
}

export default UserDataFormIndex;
